/**
 * Where a title's artwork is served from.
 *
 * The browser builds these URLs for every card in the catalogue without asking
 * anything, and the API serves them; a disagreement is a page of broken images.
 * The writing side — checksums, R2, the `title_art` rows — needs bindings and
 * stays in the API.
 */
import type { TitleArtKind } from './contracts/enums';

export function titleArtPath(productId: string, kind: TitleArtKind): string {
  return `/v1/content/title-art/${productId}/${kind}`;
}
